/* eslint-env browser */

(function (window) {
    'use strict';

    var SECTION_LABELS = {
        essence: 'Essenza',
        work: 'Lavoro',
        love: 'Amore',
        change: 'Cambiamento',
        silence: 'Silenzio',
        work_career: 'Lavoro',
        love_relationships: 'Amore'
    };

    var DAILY_SECTION_LABELS = {
        relazioni: 'Relazioni',
        lavoro: 'Lavoro',
        benessere: 'Benessere',
        crescita: 'Crescita'
    };

    var DAILY_SECTION_ORDER = ['relazioni', 'lavoro', 'benessere', 'crescita'];

    var REQUIRED_TIERS = {
        personal: 'siwa-personal',
        publisher: 'siwa-publisher'
    };

    function escapeHtml(text) {
        var div = document.createElement('div');
        div.textContent = text == null ? '' : String(text);
        return div.innerHTML;
    }

    function formatDate(value) {
        if (!value) {
            return '';
        }
        try {
            return new Date(value).toLocaleDateString('it-IT', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        } catch (e) {
            return value;
        }
    }

    function formatHoroscopeTitle(dateValue) {
        var formatted = formatDate(dateValue);
        return formatted ? ('Oroscopo del ' + formatted) : 'Oroscopo';
    }

    function isHoroscopeToday(dateValue) {
        if (!dateValue) {
            return false;
        }
        var iso = String(dateValue).split('T')[0];
        var parts = iso.split('-');
        if (parts.length !== 3) {
            return false;
        }
        var now = new Date();
        return (
            Number(parts[0]) === now.getFullYear() &&
            Number(parts[1]) === now.getMonth() + 1 &&
            Number(parts[2]) === now.getDate()
        );
    }

    function renderPushBanner() {
        if (!window.SiwaPush || !window.SiwaPush.supportsPush()) {
            return '';
        }
        return (
            '<div class="siwa-push-banner" data-siwa-push-root hidden>' +
            '<div class="siwa-push-banner__enable" data-siwa-push-enable-wrap>' +
            '<p class="siwa-push-banner__text">Ricevi l\'oroscopo ogni mattina come notifica sul dispositivo.</p>' +
            '<button type="button" class="siwa-btn siwa-btn-ghost siwa-btn-sm" data-siwa-push-enable>Attiva notifiche</button>' +
            '</div>' +
            '<div class="siwa-push-banner__active" data-siwa-push-active-wrap hidden>' +
            '<span class="siwa-push-banner__badge">Notifiche attive</span>' +
            '<button type="button" class="siwa-btn siwa-btn-ghost siwa-btn-sm" data-siwa-push-disable>Disattiva</button>' +
            '</div>' +
            '<p class="siwa-push-banner__denied siwa-muted" data-siwa-push-denied hidden>Notifiche bloccate dal browser. Abilitale dalle impostazioni del sito.</p>' +
            '<p class="siwa-push-banner__message" data-siwa-push-message hidden></p>' +
            '</div>'
        );
    }

    function pad2(value) {
        return String(value).padStart(2, '0');
    }

    function formatBirthSummary(profile) {
        if (!profile || !profile.name) {
            return '';
        }

        var parts = [profile.name];
        if (profile.day && profile.month && profile.year) {
            parts.push(
                pad2(profile.day) + '/' + pad2(profile.month) + '/' + profile.year +
                (profile.hour != null ? ' · ' + pad2(profile.hour) + ':' + pad2(profile.minute || 0) : '')
            );
        }
        if (profile.city) {
            parts.push(profile.city);
        }
        return parts.join(' · ');
    }

    function renderError(root, message) {
        root.innerHTML =
            '<div class="siwa-alert siwa-alert-error"><p>' + escapeHtml(message) + '</p></div>';
    }

    function isLandingPreview() {
        try {
            return new URLSearchParams(window.location.search).get('landing') === 'true';
        } catch (e) {
            return false;
        }
    }

    function landingElementId(product) {
        return product === 'publisher' ? 'siwa-landing-publisher' : 'siwa-landing-personal';
    }

    function setLandingBanners(landingEl, mode) {
        if (!landingEl) {
            return;
        }
        var guestBanner = landingEl.querySelector('[data-siwa-landing-guest]');
        var wrongBanner = landingEl.querySelector('[data-siwa-landing-wrong-tier]');
        if (mode === 'preview') {
            if (guestBanner) {
                guestBanner.hidden = true;
            }
            if (wrongBanner) {
                wrongBanner.hidden = true;
            }
            return;
        }
        if (guestBanner) {
            guestBanner.hidden = mode === 'wrong-tier';
        }
        if (wrongBanner) {
            wrongBanner.hidden = mode !== 'wrong-tier';
        }
    }

    function showProductLanding(product, mode) {
        var landingEl = document.getElementById(landingElementId(product));
        var dashboardWrap = document.getElementById('siwa-dashboard-wrap');
        if (landingEl) {
            landingEl.hidden = false;
            setLandingBanners(landingEl, mode || 'guest');
        }
        if (dashboardWrap) {
            dashboardWrap.hidden = true;
        }
    }

    function showProductDashboard(product, root) {
        var landingEl = document.getElementById(landingElementId(product));
        var dashboardWrap = document.getElementById('siwa-dashboard-wrap');
        if (landingEl) {
            landingEl.hidden = true;
        }
        if (dashboardWrap) {
            dashboardWrap.hidden = false;
        }

        var loader = product === 'publisher'
            ? loadPublisherDashboard(root)
            : loadPersonalDashboard(root);

        return loader.then(function () {
            if (product === 'personal') {
                startNatalPolling(root);
            }
        });
    }

    function renderSection(title, bodyHtml, actionsHtml, extraClass) {
        var cardClass = 'siwa-dash-card' + (extraClass ? ' ' + extraClass : '');
        return (
            '<section class="' + cardClass + '">' +
            '<div class="siwa-dash-card-head">' +
            '<h2 class="siwa-dash-card-title">' + escapeHtml(title) + '</h2>' +
            (actionsHtml || '') +
            '</div>' +
            '<div class="siwa-dash-card-body">' + bodyHtml + '</div>' +
            '</section>'
        );
    }

    function renderHoroscopeSections(sections, labels, order) {
        if (!sections || typeof sections !== 'object') {
            return '<p class="siwa-muted">Nessuna sezione disponibile.</p>';
        }

        var keys = order || Object.keys(sections);
        keys = keys.filter(function (key) {
            return sections[key];
        });

        if (!keys.length) {
            return '<p class="siwa-muted">Nessuna sezione disponibile.</p>';
        }

        return keys.map(function (key) {
            var label = (labels && labels[key]) || key;
            return (
                '<div class="siwa-horoscope-section">' +
                '<h3 class="siwa-horoscope-section__title">' + escapeHtml(label) + '</h3>' +
                '<p>' + escapeHtml(sections[key]) + '</p>' +
                '</div>'
            );
        }).join('');
    }

    function sunSignFromBirth(month, day) {
        var md = (month * 100) + day;
        var key;
        var labels = {
            capricorno: 'Capricorno',
            acquario: 'Acquario',
            pesci: 'Pesci',
            ariete: 'Ariete',
            toro: 'Toro',
            gemelli: 'Gemelli',
            cancro: 'Cancro',
            leone: 'Leone',
            vergine: 'Vergine',
            bilancia: 'Bilancia',
            scorpione: 'Scorpione',
            sagittario: 'Sagittario'
        };
        var modifiers = {
            capricorno: 'capricorn',
            acquario: 'aquarius',
            pesci: 'pisces',
            ariete: 'aries',
            toro: 'taurus',
            gemelli: 'gemini',
            cancro: 'cancer',
            leone: 'leo',
            vergine: 'virgo',
            bilancia: 'libra',
            scorpione: 'scorpio',
            sagittario: 'sagittarius'
        };

        if (md >= 1222 || md <= 119) {
            key = 'capricorno';
        } else if (md <= 218) {
            key = 'acquario';
        } else if (md <= 320) {
            key = 'pesci';
        } else if (md <= 419) {
            key = 'ariete';
        } else if (md <= 520) {
            key = 'toro';
        } else if (md <= 620) {
            key = 'gemelli';
        } else if (md <= 721) {
            key = 'cancro';
        } else if (md <= 822) {
            key = 'leone';
        } else if (md <= 922) {
            key = 'vergine';
        } else if (md <= 1022) {
            key = 'bilancia';
        } else if (md <= 1121) {
            key = 'scorpione';
        } else {
            key = 'sagittario';
        }

        return {
            label: labels[key],
            imageUrl: window.location.origin + '/assets/images/' + modifiers[key] + '.jpg'
        };
    }

    function renderTodayHoroscope(today, profile) {
        var sections = today.sections || {};
        var hasSections = Object.keys(sections).some(function (key) {
            return sections[key];
        });
        var narrative = today.daily_text || (hasSections ? '' : today.full_text);
        var sunLabel = today.sun_sign_label;
        var sunImage = today.sun_sign_image;

        if ((!sunLabel || !sunImage) && profile && profile.month && profile.day) {
            var sign = sunSignFromBirth(profile.month, profile.day);
            sunLabel = sign.label;
            sunImage = sign.imageUrl;
        }

        var html = '';

        if (sunImage) {
            html +=
                '<figure class="siwa-today-sign">' +
                '<img src="' + escapeHtml(sunImage) + '" alt="' + escapeHtml(sunLabel || 'Segno zodiacale') + '" loading="lazy" />' +
                (sunLabel ? '<figcaption>' + escapeHtml(sunLabel) + '</figcaption>' : '') +
                '</figure>';
        }

        if (narrative) {
            html += '<div class="siwa-horoscope-lead">' +
                narrative.split(/\n\n+/).map(function (paragraph) {
                    return '<p>' + escapeHtml(paragraph.trim()) + '</p>';
                }).join('') +
                '</div>';
        }

        if (hasSections) {
            html += renderHoroscopeSections(sections, DAILY_SECTION_LABELS, DAILY_SECTION_ORDER);
        }

        return html;
    }

    var HOUSE_LABELS = {
        First_House: 'Casa I',
        Second_House: 'Casa II',
        Third_House: 'Casa III',
        Fourth_House: 'Casa IV',
        Fifth_House: 'Casa V',
        Sixth_House: 'Casa VI',
        Seventh_House: 'Casa VII',
        Eighth_House: 'Casa VIII',
        Ninth_House: 'Casa IX',
        Tenth_House: 'Casa X',
        Eleventh_House: 'Casa XI',
        Twelfth_House: 'Casa XII'
    };

    var HOUSE_ROMAN = ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];

    var natalSvgCache = {};

    function labelHouse(house) {
        if (house == null || house === '') {
            return '—';
        }
        if (typeof house === 'number' && house >= 1 && house <= 12) {
            return 'Casa ' + HOUSE_ROMAN[house];
        }
        var key = String(house);
        if (HOUSE_LABELS[key]) {
            return HOUSE_LABELS[key];
        }
        var normalized = key.replace(/ /g, '_');
        if (HOUSE_LABELS[normalized]) {
            return HOUSE_LABELS[normalized];
        }
        return key.replace(/_/g, ' ');
    }

    function fetchChartSvg(url) {
        if (!url) {
            return Promise.reject(new Error('URL SVG mancante'));
        }
        if (natalSvgCache[url]) {
            return Promise.resolve(natalSvgCache[url]);
        }
        return fetch(url, { credentials: 'same-origin' })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Impossibile caricare la carta natalizia');
                }
                return response.text();
            })
            .then(function (text) {
                natalSvgCache[url] = text;
                return text;
            });
    }

    function prepareInlineSvg(svgText) {
        var template = document.createElement('template');
        template.innerHTML = svgText.trim();
        var svg = template.content.querySelector('svg');
        if (!svg) {
            return svgText;
        }
        svg.setAttribute('width', '100%');
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        svg.removeAttribute('height');
        svg.style.display = 'block';
        svg.style.width = '100%';
        svg.style.height = 'auto';
        svg.setAttribute('role', 'img');
        return svg.outerHTML;
    }

    function renderChartFigure(caption, pngUrl, svgUrl) {
        if (!pngUrl && !svgUrl) {
            return '';
        }
        var chartUrl = svgUrl || pngUrl;
        var chartType = svgUrl ? 'svg' : 'png';
        var html = '<figure class="siwa-natal-chart-figure">';
        if (caption) {
            html += '<figcaption class="siwa-natal-chart-figure__title">' + escapeHtml(caption) + '</figcaption>';
        }
        html += '<button type="button" class="siwa-natal-chart-figure__viewport" ' +
            'data-siwa-natal-chart ' +
            'data-chart-url="' + escapeHtml(apiAssetUrl(chartUrl)) + '" ' +
            'data-chart-type="' + chartType + '" ' +
            'data-chart-caption="' + escapeHtml(caption || 'Carta natalizia') + '" ' +
            'aria-label="Ingrandisci ' + escapeHtml(caption || 'carta natalizia') + '">';
        if (chartType === 'svg') {
            html += '<div class="siwa-natal-chart-figure__svg" data-siwa-natal-svg-host></div>';
        } else {
            html += '<img src="' + escapeHtml(apiAssetUrl(pngUrl)) + '" alt="' + escapeHtml(caption || 'Carta natalizia') + '" loading="lazy" />';
        }
        html += '</button></figure>';
        return html;
    }

    function renderNatalCharts(charts) {
        if (!charts) {
            return '';
        }

        var html = '<div class="siwa-natal-charts">';
        var hasImage = charts.chart_wheel_png_url || charts.chart_wheel_svg_url ||
            charts.chart_grid_png_url || charts.chart_grid_svg_url ||
            charts.chart_png_url || charts.chart_svg_url;

        if (hasImage) {
            html += '<div class="siwa-natal-charts__images">';
            html += renderChartFigure(
                'Ruota natalizia',
                charts.chart_wheel_png_url,
                charts.chart_wheel_svg_url
            );
            html += renderChartFigure(
                'Griglia degli aspetti',
                charts.chart_grid_png_url,
                charts.chart_grid_svg_url
            );
            if (!charts.chart_wheel_png_url && !charts.chart_wheel_svg_url &&
                !charts.chart_grid_png_url && !charts.chart_grid_svg_url) {
                html += renderChartFigure(
                    'Tema natale',
                    charts.chart_png_url,
                    charts.chart_svg_url
                );
            }
            html += '</div>';
        }

        var planets = charts.planets || [];
        if (planets.length) {
            html += '<div class="siwa-natal-planets">' +
                '<h3 class="siwa-natal-planets__title">Posizioni planetarie</h3>' +
                '<div class="siwa-natal-planets__scroll">' +
                '<table class="siwa-natal-planets__table">' +
                '<thead><tr><th>Pianeta</th><th>Segno</th><th>Posizione</th><th>Casa</th></tr></thead><tbody>';
            planets.forEach(function (planet) {
                var house = labelHouse(planet.house);
                var retro = planet.retrograde ? ' ℞' : '';
                html += '<tr>' +
                    '<td>' + escapeHtml(planet.name + retro) + '</td>' +
                    '<td>' + escapeHtml(planet.sign || '—') + '</td>' +
                    '<td>' + escapeHtml(planet.position || '—') + '</td>' +
                    '<td>' + escapeHtml(house) + '</td>' +
                    '</tr>';
            });
            html += '</tbody></table></div></div>';
        }

        var aspects = charts.aspects || [];
        if (aspects.length) {
            html += '<details class="siwa-natal-aspects">' +
                '<summary class="siwa-natal-planets__title">Aspetti principali</summary>' +
                '<ul class="siwa-natal-aspects__list">';
            aspects.forEach(function (aspect) {
                var label = [aspect.p1_name, aspect.aspect, aspect.p2_name].filter(Boolean).join(' · ');
                html += '<li>' + escapeHtml(label) + '</li>';
            });
            html += '</ul></details>';
        }

        html += '</div>';
        return html;
    }

    function renderNatalChartModal() {
        return (
            '<div class="siwa-natal-lightbox" id="siwa-natal-lightbox" hidden>' +
            '<div class="siwa-natal-lightbox__backdrop" data-siwa-natal-close></div>' +
            '<div class="siwa-natal-lightbox__panel" role="dialog" aria-labelledby="siwa-natal-lightbox-title" aria-modal="true">' +
            '<button type="button" class="siwa-natal-lightbox__close" data-siwa-natal-close aria-label="Chiudi">&times;</button>' +
            '<h3 id="siwa-natal-lightbox-title" class="siwa-natal-lightbox__title"></h3>' +
            '<div class="siwa-natal-lightbox__body" id="siwa-natal-lightbox-body"></div>' +
            '</div>' +
            '</div>'
        );
    }

    function closeNatalChartLightbox() {
        var modal = document.getElementById('siwa-natal-lightbox');
        if (!modal) {
            return;
        }
        modal.hidden = true;
        document.body.classList.remove('siwa-natal-lightbox-open');
        var bodyEl = document.getElementById('siwa-natal-lightbox-body');
        if (bodyEl) {
            bodyEl.innerHTML = '';
        }
    }

    function openNatalChartLightbox(url, chartType, caption) {
        var modal = document.getElementById('siwa-natal-lightbox');
        var titleEl = document.getElementById('siwa-natal-lightbox-title');
        var bodyEl = document.getElementById('siwa-natal-lightbox-body');
        if (!modal || !bodyEl) {
            return;
        }

        if (titleEl) {
            titleEl.textContent = caption || 'Carta natalizia';
        }
        bodyEl.innerHTML = '<p class="siwa-muted">Caricamento…</p>';
        modal.hidden = false;
        document.body.classList.add('siwa-natal-lightbox-open');

        if (chartType === 'svg') {
            fetchChartSvg(url)
                .then(function (svgText) {
                    bodyEl.innerHTML = '<div class="siwa-natal-lightbox__svg">' + prepareInlineSvg(svgText) + '</div>';
                })
                .catch(function () {
                    bodyEl.innerHTML = '<p class="siwa-muted">Impossibile caricare la carta natalizia.</p>';
                });
            return;
        }

        bodyEl.innerHTML =
            '<img class="siwa-natal-lightbox__image" src="' + escapeHtml(url) + '" alt="' + escapeHtml(caption || 'Carta natalizia') + '" />';
    }

    function hydrateNatalCharts(root) {
        root.querySelectorAll('[data-siwa-natal-svg-host]').forEach(function (host) {
            if (host.getAttribute('data-siwa-natal-loaded') === '1') {
                return;
            }
            var button = host.closest('[data-siwa-natal-chart]');
            if (!button) {
                return;
            }
            var url = button.getAttribute('data-chart-url');
            if (!url) {
                return;
            }
            host.setAttribute('data-siwa-natal-loaded', '1');
            fetchChartSvg(url)
                .then(function (svgText) {
                    host.innerHTML = prepareInlineSvg(svgText);
                })
                .catch(function () {
                    host.innerHTML = '<p class="siwa-muted">Impossibile caricare la carta.</p>';
                    host.removeAttribute('data-siwa-natal-loaded');
                });
        });
    }

    function bindNatalChartEvents(root) {
        root.querySelectorAll('[data-siwa-natal-chart]').forEach(function (button) {
            if (button.getAttribute('data-siwa-natal-bound') === '1') {
                return;
            }
            button.setAttribute('data-siwa-natal-bound', '1');
            button.addEventListener('click', function () {
                openNatalChartLightbox(
                    button.getAttribute('data-chart-url'),
                    button.getAttribute('data-chart-type'),
                    button.getAttribute('data-chart-caption')
                );
            });
        });

        if (root.getAttribute('data-siwa-natal-modal-bound') === '1') {
            return;
        }
        root.setAttribute('data-siwa-natal-modal-bound', '1');
        root.addEventListener('click', function (event) {
            if (event.target.closest('[data-siwa-natal-close]')) {
                closeNatalChartLightbox();
            }
        });
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                closeNatalChartLightbox();
            }
        });
    }

    function renderArchiveModal() {
        return (
            '<div class="siwa-archive-modal" id="siwa-archive-modal" hidden>' +
            '<div class="siwa-archive-modal__backdrop" data-siwa-archive-close></div>' +
            '<div class="siwa-archive-modal__panel" role="dialog" aria-labelledby="siwa-archive-modal-title" aria-modal="true">' +
            '<button type="button" class="siwa-archive-modal__close" data-siwa-archive-close aria-label="Chiudi">&times;</button>' +
            '<h3 id="siwa-archive-modal-title" class="siwa-archive-modal__title">Oroscopo</h3>' +
            '<p class="siwa-archive-modal__date siwa-muted" id="siwa-archive-modal-date"></p>' +
            '<div class="siwa-archive-modal__body" id="siwa-archive-modal-body"></div>' +
            '<p class="siwa-archive-modal__status siwa-muted" id="siwa-archive-modal-status" hidden></p>' +
            '</div>' +
            '</div>'
        );
    }

    function closeArchiveModal() {
        var modal = document.getElementById('siwa-archive-modal');
        if (!modal) {
            return;
        }
        modal.hidden = true;
        document.body.classList.remove('siwa-archive-modal-open');
    }

    function openArchiveHoroscope(dateStr, profile) {
        var modal = document.getElementById('siwa-archive-modal');
        var titleEl = document.getElementById('siwa-archive-modal-date');
        var bodyEl = document.getElementById('siwa-archive-modal-body');
        var statusEl = document.getElementById('siwa-archive-modal-status');
        if (!modal || !bodyEl) {
            return;
        }

        if (statusEl) {
            statusEl.hidden = false;
            statusEl.textContent = 'Caricamento…';
        }
        bodyEl.innerHTML = '';
        if (titleEl) {
            titleEl.textContent = formatDate(dateStr);
        }
        modal.hidden = false;
        document.body.classList.add('siwa-archive-modal-open');

        window.SiwaApp.apiFetch('/members/me/horoscope/' + encodeURIComponent(dateStr))
            .then(function (data) {
                if (statusEl) {
                    statusEl.hidden = true;
                }
                bodyEl.innerHTML = renderTodayHoroscope(data, profile);
            })
            .catch(function (err) {
                if (statusEl) {
                    statusEl.hidden = false;
                    statusEl.textContent = err.message || 'Impossibile caricare l\'oroscopo.';
                }
            });
    }

    function bindArchiveModalEvents(root) {
        if (root.getAttribute('data-siwa-archive-bound') === '1') {
            return;
        }
        root.setAttribute('data-siwa-archive-bound', '1');

        root.addEventListener('click', function (event) {
            if (event.target.closest('[data-siwa-archive-close]')) {
                closeArchiveModal();
            }
        });
    }

    function bindArchiveItems(root, profile) {
        root.querySelectorAll('[data-siwa-archive-date]').forEach(function (button) {
            if (button.getAttribute('data-siwa-archive-bound') === '1') {
                return;
            }
            button.setAttribute('data-siwa-archive-bound', '1');
            button.addEventListener('click', function () {
                openArchiveHoroscope(button.getAttribute('data-siwa-archive-date'), profile);
            });
        });
    }

    function renderShareModal() {
        return (
            '<div class="siwa-share-modal" id="siwa-share-modal" hidden>' +
            '<div class="siwa-share-modal__backdrop" data-siwa-share-close></div>' +
            '<div class="siwa-share-modal__panel" role="dialog" aria-labelledby="siwa-share-modal-title" aria-modal="true">' +
            '<button type="button" class="siwa-share-modal__close" data-siwa-share-close aria-label="Chiudi">&times;</button>' +
            '<h3 id="siwa-share-modal-title" class="siwa-share-modal__title">Condividi il tuo oroscopo</h3>' +
            '<p class="siwa-muted siwa-share-modal__lead">Post pubblico creato su Siwa. Copia il link o salva il QR code.</p>' +
            '<div class="siwa-share-modal__link-wrap">' +
            '<input type="text" class="siwa-share-modal__link" id="siwa-share-link" readonly />' +
            '<button type="button" class="siwa-btn siwa-btn-ghost" id="siwa-share-copy">Copia link</button>' +
            '</div>' +
            '<figure class="siwa-share-modal__qr">' +
            '<img id="siwa-share-qr" alt="QR code oroscopo" width="256" height="256" />' +
            '</figure>' +
            '<div class="siwa-share-modal__actions">' +
            '<button type="button" class="siwa-btn siwa-btn-primary" id="siwa-share-native" hidden>Instagram / TikTok</button>' +
            '<a class="siwa-btn siwa-btn-primary" id="siwa-share-download" download="oroscopo.png">Salva QR code</a>' +
            '<a class="siwa-btn siwa-btn-ghost" id="siwa-share-open" target="_blank" rel="noopener">Apri post</a>' +
            '</div>' +
            '<p class="siwa-share-modal__hint siwa-muted" id="siwa-share-native-hint" hidden>Su mobile apre il menu di condivisione del telefono con QR code e testo.</p>' +
            '<p class="siwa-share-modal__status siwa-muted" id="siwa-share-status" hidden></p>' +
            '</div>' +
            '</div>'
        );
    }

    function apiAssetUrl(path) {
        var base = (window.SiwaApp && window.SiwaApp.apiBase) || (window.location.origin + '/siwa-api');
        if (!path) {
            return '';
        }
        if (path.indexOf('http') === 0) {
            return path;
        }
        if (path.charAt(0) !== '/') {
            path = '/' + path;
        }
        return base + path;
    }

    var currentShareData = null;

    function canNativeShare() {
        return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
    }

    function buildShareText(data) {
        var name = (data && data.first_name) || '';
        var url = (data && data.post_url) || '';
        var lines = ['Il mio oroscopo di oggi su Siwa.'];
        if (name) {
            lines.push('Scopri anche tu il tuo, ' + name + ':');
        } else {
            lines.push('Scopri il tuo oroscopo personalizzato:');
        }
        if (url) {
            lines.push(url);
        }
        return lines.join('\n');
    }

    function showShareStatus(message) {
        var statusEl = document.getElementById('siwa-share-status');
        if (statusEl) {
            statusEl.hidden = false;
            statusEl.textContent = message;
        }
    }

    function shareNativeWithQr(data) {
        var qrUrl = apiAssetUrl(data.qr_image_url);
        var text = buildShareText(data);
        var fileName = data.qr_download_name || 'oroscopo-siwa.png';

        return fetch(qrUrl, { credentials: 'same-origin' })
            .then(function (res) {
                if (!res.ok) {
                    throw new Error('QR non disponibile');
                }
                return res.blob();
            })
            .then(function (blob) {
                var payload = {
                    title: 'Oroscopo Siwa',
                    text: text
                };
                var file = new File([blob], fileName, { type: blob.type || 'image/png' });
                if (navigator.canShare && navigator.canShare({ files: [file] })) {
                    payload.files = [file];
                }
                return navigator.share(payload);
            })
            .catch(function (err) {
                if (err && err.name === 'AbortError') {
                    return;
                }
                return navigator.share({
                    title: 'Oroscopo Siwa',
                    text: text,
                    url: data.post_url
                });
            });
    }

    function openShareModal(data) {
        currentShareData = data;
        var modal = document.getElementById('siwa-share-modal');
        if (!modal) {
            return;
        }
        var linkInput = document.getElementById('siwa-share-link');
        var qrImg = document.getElementById('siwa-share-qr');
        var downloadLink = document.getElementById('siwa-share-download');
        var openLink = document.getElementById('siwa-share-open');
        var statusEl = document.getElementById('siwa-share-status');

        if (statusEl) {
            statusEl.hidden = true;
            statusEl.textContent = '';
        }

        if (linkInput) {
            linkInput.value = data.post_url || '';
        }
        if (openLink) {
            openLink.href = data.post_url || '#';
        }
        if (qrImg) {
            qrImg.src = apiAssetUrl(data.qr_image_url);
        }
        if (downloadLink) {
            downloadLink.href = apiAssetUrl(data.qr_image_url);
            downloadLink.download = data.qr_download_name || 'oroscopo.png';
        }

        var nativeBtn = document.getElementById('siwa-share-native');
        var nativeHint = document.getElementById('siwa-share-native-hint');
        var nativeSupported = canNativeShare();
        if (nativeBtn) {
            nativeBtn.hidden = !nativeSupported;
        }
        if (nativeHint) {
            nativeHint.hidden = !nativeSupported;
        }

        modal.hidden = false;
        document.body.classList.add('siwa-share-modal-open');
    }

    function closeShareModal() {
        var modal = document.getElementById('siwa-share-modal');
        if (!modal) {
            return;
        }
        modal.hidden = true;
        document.body.classList.remove('siwa-share-modal-open');
    }

    function bindShareModalEvents(root) {
        if (root.getAttribute('data-siwa-share-bound') === '1') {
            return;
        }
        root.setAttribute('data-siwa-share-bound', '1');

        root.addEventListener('click', function (event) {
            if (event.target.closest('[data-siwa-share-close]')) {
                closeShareModal();
            }
        });

        var copyBtn = document.getElementById('siwa-share-copy');
        if (copyBtn) {
            copyBtn.addEventListener('click', function () {
                var input = document.getElementById('siwa-share-link');
                var statusEl = document.getElementById('siwa-share-status');
                if (!input || !input.value) {
                    return;
                }
                var done = function () {
                    if (statusEl) {
                        statusEl.hidden = false;
                        statusEl.textContent = 'Link copiato negli appunti.';
                    }
                };
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(input.value).then(done).catch(function () {
                        input.select();
                        document.execCommand('copy');
                        done();
                    });
                } else {
                    input.select();
                    document.execCommand('copy');
                    done();
                }
            });
        }

        var nativeBtn = document.getElementById('siwa-share-native');
        if (nativeBtn) {
            nativeBtn.addEventListener('click', function () {
                if (!currentShareData) {
                    return;
                }
                nativeBtn.disabled = true;
                shareNativeWithQr(currentShareData)
                    .then(function () {
                        showShareStatus('Scegli Instagram, TikTok o un\'altra app dal menu.');
                    })
                    .catch(function (err) {
                        if (err && err.name === 'AbortError') {
                            return;
                        }
                        showShareStatus('Salva il QR code e incolla il link nel tuo post.');
                    })
                    .finally(function () {
                        nativeBtn.disabled = false;
                    });
            });
        }
    }

    function handleShareClick(button) {
        var statusEl = button.parentNode.querySelector('.siwa-share-inline-status');
        button.disabled = true;
        if (statusEl) {
            statusEl.hidden = false;
            statusEl.textContent = 'Creazione post in corso…';
        }

        window.SiwaApp.apiFetch('/members/me/horoscope/today/share', {
            method: 'POST'
        }).then(function (data) {
            openShareModal(data);
            if (statusEl) {
                statusEl.hidden = true;
            }
        }).catch(function (err) {
            if (statusEl) {
                statusEl.hidden = false;
                statusEl.textContent = err.message || 'Impossibile condividere l\'oroscopo.';
            }
        }).finally(function () {
            button.disabled = false;
        });
    }

    function bindShareButtons(root) {
        root.querySelectorAll('[data-siwa-share]').forEach(function (button) {
            if (button.getAttribute('data-siwa-share-bound') === '1') {
                return;
            }
            button.setAttribute('data-siwa-share-bound', '1');
            button.addEventListener('click', function () {
                handleShareClick(button);
            });
        });
    }

    function queuedHas(bootstrap, key) {
        return !!(bootstrap && bootstrap.queued && bootstrap.queued.indexOf(key) !== -1);
    }

    function renderPersonalDashboard(root, data) {
        var member = data.member || {};
        var latest = data.latest || {};
        var weekly = data.weekly || {};
        var archive = data.archive || [];
        var natal = data.natal || {};
        var bootstrap = data.bootstrap || null;
        var profile = natal.profile || {};
        var interpretation = natal.interpretation || {};
        var sections = interpretation.sections || {};
        var pendingNatal = !interpretation.excerpt &&
            !(sections && Object.keys(sections).length) &&
            member.onboarding_completed;
        var pendingToday = queuedHas(bootstrap, 'daily_horoscope');
        var hasLatest = !!(latest.full_text || latest.daily_text || (latest.sections && Object.keys(latest.sections).length));
        var horoscopeTitle = formatHoroscopeTitle(latest.horoscope_date);
        var canShare = hasLatest && isHoroscopeToday(latest.horoscope_date);

        var html = '<div class="siwa-dashboard-grid">';

        if (!member.onboarding_completed) {
            html += (
                '<div class="siwa-dash-onboarding-hint">' +
                '<p class="siwa-muted"><a href="' + escapeHtml(window.location.origin + '/siwa-personal-onboarding/') + '">Completa l\'onboarding</a> per attivare gli oroscopi personalizzati.</p>' +
                '</div>'
            );
        }

        html += renderPushBanner();

        var latestBody;
        var latestActions = '';
        if (hasLatest) {
            latestBody = renderTodayHoroscope(latest, profile);
            if (canShare) {
                latestActions =
                    '<div class="siwa-dash-card-actions">' +
                    '<button type="button" class="siwa-btn siwa-btn-primary siwa-btn-sm" data-siwa-share>Condividi</button>' +
                    '<span class="siwa-share-inline-status siwa-muted" hidden></span>' +
                    '</div>';
            }
        } else if (pendingToday) {
            latestBody = '<p class="siwa-muted">Stiamo generando il tuo oroscopo. Ricarica la pagina tra qualche minuto.</p>';
        } else {
            latestBody = '<p class="siwa-muted">Il tuo oroscopo non è ancora disponibile.</p>';
        }
        html += renderSection(horoscopeTitle, latestBody, latestActions);

        html += renderSection(
            'Settimana',
            weekly.summary_text
                ? '<p>' + escapeHtml(weekly.summary_text) + '</p>'
                : '<p class="siwa-muted">La panoramica settimanale sarà disponibile dopo i primi oroscopi giornalieri.</p>'
        );

        var natalBody = '';
        var birthSummary = formatBirthSummary(profile);
        if (birthSummary) {
            natalBody += '<p class="siwa-natal-meta">' + escapeHtml(birthSummary) + '</p>';
        }
        if (natal.charts) {
            natalBody += renderNatalCharts(natal.charts);
        }
        if (interpretation.excerpt) {
            natalBody += '<p class="siwa-horoscope-lead">' + escapeHtml(interpretation.excerpt) + '</p>';
        }
        if (sections && Object.keys(sections).length) {
            natalBody += renderHoroscopeSections(sections, SECTION_LABELS);
        } else if (pendingNatal) {
            natalBody += '<p class="siwa-muted">Stiamo preparando l\'interpretazione del tuo tema natale. Ricarica la pagina tra qualche minuto.</p>';
        } else if (member.onboarding_completed) {
            natalBody += '<p class="siwa-muted">Interpretazione tema natale non ancora disponibile. Se il messaggio persiste, contatta il supporto.</p>';
        } else {
            natalBody += '<p class="siwa-muted">Completa l\'onboarding per generare il tema natale.</p>';
        }
        html += renderSection('Tema natale', natalBody, '', 'siwa-dash-card--natal');

        var archiveBody;
        if (archive.length) {
            archiveBody = '<ul class="siwa-archive-list">' + archive.map(function (item) {
                var dateValue = item.horoscope_date || item.date;
                return (
                    '<li class="siwa-archive-item">' +
                    '<button type="button" class="siwa-archive-link" data-siwa-archive-date="' + escapeHtml(dateValue) + '">' +
                    '<span class="siwa-archive-date">' + escapeHtml(formatDate(dateValue)) + '</span>' +
                    '<span class="siwa-archive-excerpt">' + escapeHtml(item.excerpt || item.full_text || '') + '</span>' +
                    '<span class="siwa-archive-open">Apri →</span>' +
                    '</button>' +
                    '</li>'
                );
            }).join('') + '</ul>';
        } else {
            archiveBody = '<p class="siwa-muted">Nessun oroscopo in archivio ancora. I giorni precedenti compariranno qui man mano.</p>';
        }
        html += renderSection('Archivio', archiveBody);

        html += '</div>';
        html += renderShareModal();
        html += renderArchiveModal();
        html += renderNatalChartModal();
        root.innerHTML = html;
        bindShareModalEvents(root);
        bindShareButtons(root);
        bindArchiveModalEvents(root);
        bindArchiveItems(root, profile);
        hydrateNatalCharts(root);
        bindNatalChartEvents(root);

        if (pendingNatal) {
            root.setAttribute('data-siwa-natal-pending', '1');
        } else {
            root.removeAttribute('data-siwa-natal-pending');
        }

        if (window.SiwaPush) {
            window.SiwaPush.init(root);
        }
    }

    function renderPublisherDashboard(root, data) {
        var config = data.config || {};
        var runs = data.runs || [];
        var onboardingUrl = window.location.origin + '/siwa-publisher-onboarding/';

        var configHtml;
        if (!config.id) {
            configHtml =
                '<div class="siwa-publisher-setup">' +
                '<p class="siwa-publisher-setup__lead">Collega il tuo sito Ghost o WordPress e scegli quando pubblicare l\'oroscopo. ' +
                'La configurazione richiede pochi minuti; dopo Siwa pubblica in automatico ogni giorno.</p>' +
                '<a class="siwa-btn siwa-btn-primary" href="' + escapeHtml(onboardingUrl) + '">Configura Publisher</a>' +
                '</div>';
        } else {
            configHtml =
                '<div class="siwa-config-list">' +
                '<div class="siwa-config-list__row"><span class="siwa-config-list__label">CMS</span><span class="siwa-config-list__value">' + escapeHtml(config.cms_type || '—') + '</span></div>' +
                '<div class="siwa-config-list__row"><span class="siwa-config-list__label">Sito</span><span class="siwa-config-list__value">' + escapeHtml(config.site_url || '—') + '</span></div>' +
                '<div class="siwa-config-list__row"><span class="siwa-config-list__label">Pubblicazione</span><span class="siwa-config-list__value">' + escapeHtml(config.publish_time || '—') + ' (' + escapeHtml(config.tz || '—') + ')</span></div>' +
                '<div class="siwa-config-list__row"><span class="siwa-config-list__label">Modalità</span><span class="siwa-config-list__value">' + escapeHtml(config.publish_mode || '—') + '</span></div>' +
                '<div class="siwa-config-list__row"><span class="siwa-config-list__label">Strategia</span><span class="siwa-config-list__value">' + escapeHtml(config.post_strategy || '—') + '</span></div>' +
                '</div>' +
                '<p class="siwa-muted siwa-publisher-setup__edit">' +
                '<a href="' + escapeHtml(onboardingUrl) + '">Modifica configurazione</a>' +
                '</p>';
        }

        var runsHtml = runs.length
            ? '<ul class="siwa-runs-list">' + runs.map(function (run) {
                return (
                    '<li class="siwa-run-item">' +
                    '<span class="siwa-run-date">' + escapeHtml(formatDate(run.run_date)) + '</span> ' +
                    '<span class="siwa-run-status siwa-run-status--' + escapeHtml(run.status || 'pending') + '">' + escapeHtml(run.status || 'pending') + '</span>' +
                    (run.error_message ? '<p class="siwa-run-error">' + escapeHtml(run.error_message) + '</p>' : '') +
                    '</li>'
                );
            }).join('') + '</ul>'
            : '<p class="siwa-muted">Nessuna esecuzione registrata.</p>';

        root.innerHTML =
            '<div class="siwa-dashboard-grid">' +
            renderSection('Configurazione', configHtml) +
            renderSection('Ultime pubblicazioni', runsHtml) +
            '</div>';
    }

    function bootstrapPersonalContent() {
        return window.SiwaApp.apiFetch('/members/me/bootstrap-content', {
            method: 'POST'
        }).catch(function () {
            return null;
        });
    }

    function loadPersonalDashboard(root) {
        return bootstrapPersonalContent().then(function (bootstrap) {
            return Promise.all([
                window.SiwaApp.apiFetch('/members/me'),
                window.SiwaApp.apiFetch('/members/me/horoscope/latest').catch(function () { return null; }),
                window.SiwaApp.apiFetch('/members/me/horoscope/weekly').catch(function () { return null; }),
                window.SiwaApp.apiFetch('/members/me/horoscope/archive').catch(function () { return { items: [] }; }),
                window.SiwaApp.apiFetch('/members/me/natal').catch(function () { return null; })
            ]).then(function (results) {
                renderPersonalDashboard(root, {
                    member: results[0] || {},
                    latest: results[1] || {},
                    weekly: results[2] || {},
                    archive: (results[3] && results[3].items) || [],
                    natal: results[4] || {},
                    bootstrap: bootstrap
                });
            });
        });
    }

    var natalPollTimer = null;

    function startNatalPolling(root) {
        if (natalPollTimer) {
            clearInterval(natalPollTimer);
            natalPollTimer = null;
        }
        if (root.getAttribute('data-siwa-natal-pending') !== '1') {
            return;
        }
        natalPollTimer = setInterval(function () {
            window.SiwaApp.apiFetch('/members/me/natal')
                .then(function (natal) {
                    var interpretation = (natal && natal.interpretation) || {};
                    var sections = interpretation.sections || {};
                    var ready = interpretation.excerpt || Object.keys(sections).length;
                    if (ready) {
                        clearInterval(natalPollTimer);
                        natalPollTimer = null;
                        loadPersonalDashboard(root);
                    }
                })
                .catch(function () {});
        }, 15000);
    }

    function loadPublisherDashboard(root) {
        return Promise.all([
            window.SiwaApp.apiFetch('/publisher/config').catch(function (err) {
                if (err.status === 404) {
                    return {};
                }
                throw err;
            }),
            window.SiwaApp.apiFetch('/publisher/runs').catch(function (err) {
                if (err.status === 404) {
                    return { items: [] };
                }
                throw err;
            })
        ]).then(function (results) {
            renderPublisherDashboard(root, {
                config: results[0] || {},
                runs: (results[1] && results[1].items) || results[1] || []
            });
        });
    }

    function init() {
        var root = document.getElementById('siwa-dashboard-root');
        if (!root || !window.SiwaApp) {
            return;
        }

        var dashboardType = root.getAttribute('data-siwa-dashboard');
        var requiredTier = REQUIRED_TIERS[dashboardType];

        if (!requiredTier) {
            renderError(root, 'Dashboard non configurata.');
            return;
        }

        window.SiwaApp.resolveMemberTier()
            .then(function (tierSlug) {
                if (isLandingPreview()) {
                    showProductLanding(dashboardType, 'preview');
                    return;
                }

                if ((tierSlug || '') !== requiredTier) {
                    showProductLanding(dashboardType, 'wrong-tier');
                    return;
                }

                return showProductDashboard(dashboardType, root);
            })
            .catch(function (err) {
                renderError(root, err.message || 'Impossibile caricare la dashboard.');
            });
    }

    window.SiwaDashboard = {
        init: init
    };
})(window);
